import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class TitlePageService {
  public name = new Subject();
  TitlePageService: any;
}
